<div
  *ngIf="loading && ready"
  class="absolute inset-0 z-10 m-0 rounded-lg flex items-center justify-center bg-gray opacity-90"
>
  <common-loading-spinner
    size="32"
    [loadingText]="loadingText"
  ></common-loading-spinner>
</div>
